export const GOVGR_LINK = "govgr-link";
